import { AMONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import { NON_GERE } from '@/configuration/gabed/materiel/materielConf';
import { DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/tlpe/tlpeConf';
import genereElementMaterielNumerique from './genererElementMaterielNumerique';

export default function genererMateriel() {
  return {
    faces: [],
    code: '',
    disposition: '',
    enVenantDe: '',
    enAllantVers: '',
    etat: AMONTE,
    dateMontage: null,
    dateDemontage: null,
    visibleSurLa: null,
    azimut: null,
    visibleDunFeu: false,
    visibleDuneIntersection: false,
    eclaire: false,
    actif: true,
    isolement: null,
    ecartAxe: '',
    ecartVoie: '',
    longueurApproche: '',
    dispositifId: '',
    localisationId: '',
    angleVisionId: '',
    declarableEnMairie: false,
    surface: {
      surfaceCommerciale: null,
      surfaceTlpe: null,
    },
    typeId: '',
    formatId: '',
    numerique: false,
    commentaire: null,
    informationsNumeriques: genereElementMaterielNumerique(),
    materielTechnique: {
      typeEclairage: '',
      passerelle: false,
      longueur: null,
      largeur: null,
      formatAfficheId: null,
    },
    descriptionTlpe: DISPOSITIF_PUBLICITAIRE,
    etatMontageTlpe: NON_GERE,
    etatDemontageTlpe: NON_GERE,
    tags: [],
  };
}
